import { ChevronRightSmall, ChevronLeftSmall } from '@indriver/mireska';
import { variables } from '@indriver/yrel';
import React__default, { useMemo } from 'react';
import { ChevronContainer } from './chevron.styles.js';
import { CellSuffix } from '../cell-suffix/cell-suffix.js';

var Chevron = function Chevron(props) {
  var dir = props.dir,
      design = props.design,
      disabled = props.disabled,
      suffix = props.suffix;
  var iconProps = useMemo(function () {
    return {
      size: 24,
      color: disabled ? variables['text-and-icon-disabled'] : variables['text-and-icon-secondary']
    };
  }, [design]);
  return /*#__PURE__*/React__default.createElement(ChevronContainer, null, suffix ? /*#__PURE__*/React__default.createElement(CellSuffix, null, suffix) : null, dir === 'ltr' ? /*#__PURE__*/React__default.createElement(ChevronRightSmall, iconProps) : /*#__PURE__*/React__default.createElement(ChevronLeftSmall, iconProps));
};

export { Chevron };
